import { observer } from "mobx-react-lite";
import React from "react";

import { BuildSituation, IconName } from "../types";
import IconButton from "./IconButton";

const BuildSituationSelector = observer(
  (props: {
    onClick: (buildSituation: BuildSituation) => void;
    selected: BuildSituation | null;
  }) => {
    return (
      <div className={"pyht-house-type-selector"}>
        <IconButton
          active={props.selected === BuildSituation.FIRST_HOME_BUYER}
          icon={IconName.LAND_SITUATION_NSW_DESKTOP_VACANT}
          size={"large"}
          highlightStyle={"tick"}
          title={"First Home Buyer"}
          onClick={() => props.onClick(BuildSituation.FIRST_HOME_BUYER)}
        />
        <IconButton
          active={props.selected === BuildSituation.KNOCK_DOWN_REBUILD}
          icon={IconName.LAND_SITUATION_NSW_DESKTOP_KDR}
          size={"large"}
          highlightStyle={"tick"}
          title={"Knock Down Rebuild/ Upsizing"}
          onClick={() => props.onClick(BuildSituation.KNOCK_DOWN_REBUILD)}
        />
        <IconButton
          active={props.selected === BuildSituation.INVESTOR}
          icon={IconName.LAND_SITUATION_NSW_DESKTOP_HL}
          size={"large"}
          highlightStyle={"tick"}
          title={"Investor"}
          onClick={() => props.onClick(BuildSituation.INVESTOR)}
        />
      </div>
    );
  }
);

export default BuildSituationSelector;
